import PropTypes from 'prop-types';
import {
  connect,
} from "components/atoms/DependencyHelper";
import labels from "../../../config/labels";

import styles from "./CTADescription.module.scss";

const CTADescription = (props) => {
  let imgUrl = '';
  let ctaText = null;

  if (props.isUpgradeQualificationPrompt) {
    imgUrl = `${props.imagePrefix}/assets/images/upgradenew.svg`;
    ctaText = (
      <span>
        <span className={styles.upgrade}> Upgrade check required </span>
        <p className={styles["cta-txt-info"]}>
          {props.isUpgradeEnabled
            ? labels.upgrade.lbl_upgrade_add_to_cart_info
            : labels.upgrade.lbl_upgrade_qualify_info}
        </p>
      </span>
    );
  } else if (props.userLoggedIn && props.eligibleUpgradeList.length == 0) {
    imgUrl = `${props.imagePrefix}/assets/images/icon-cross.svg`;
    ctaText = (
      <p className={styles["cta-txt-warning"]}>
        {labels.upgrade.lbl_cant_upgrade}{" "}
        <a onClick={props.handleFindOut} className={styles["info-link"]}>
          {labels.upgrade.lbl_find_out_why}
        </a>
      </p>
    );
  } else {
   imgUrl = `${props.imagePrefix}/assets/images/upgradenew.svg`;
    ctaText = (
      <span>
      <span className={styles.upgrade}> Upgrade check required </span>
      <p className={styles["cta-txt-info"]}>
        {labels.upgrade.lbl_upgrade_due_info}
      </p>
      </span>
    );
  }

  return (
    <div className={styles["cta-txt"]}>
      <img
        src={imgUrl}
        className={styles["cta-txt-icon"]}
      />
      {ctaText}
    </div>
  );
};

CTADescription.propTypes = {
  imagePrefix: PropTypes.string,
  isUpgradeEnabled: PropTypes.bool, //features?.upgradeEnabled
  handleFindOut: PropTypes.func,

  // redux
  eligibleUpgradeList: PropTypes.arrayOf(PropTypes.object),
  isUpgradeQualificationPrompt: PropTypes.bool,
  upgradeCheckDone: PropTypes.bool, 
  userLoggedIn: PropTypes.bool,
}

const mapStateToProps = (state) => ({
  eligibleUpgradeList: state.upgrade.eligibleUpgradeList,
  isUpgradeQualificationPrompt: state.upgrade.upgradeCheckDone
    && (state.upgrade.upgradeResponse?.eligibilityStatus || state.upgrade.upgradeResponse?.upgradeEligible),
  upgradeCheckDone: state.upgrade.upgradeCheckDone,
  userLoggedIn: state.navDetails.isUserLoggedIn,
})

export default connect(mapStateToProps, {})(CTADescription);
